import * as Yup from "yup";

export const PaybackTimeMonthsValidation = () =>
  Yup.number()
    .typeError("Repayment time is required")
    .required("Repayment time is required")
    .min(
      1,
      (schema) =>
        `Repayment time can't be less than ${schema.min} month${schema.min === 1 ? "" : "s"}`,
    );
